import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ConfirmationService, MessageService, SharedModule } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DepartmentDto } from '../../../model/common/common.model';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { WarehouseService } from '../../../services/warehouse.service';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-department-default-lookup',
  standalone: true,
  imports: [CommonModule, SharedModule, TableModule, DropdownModule, CalendarModule, FormsModule, ToastModule],
  providers: [MessageService, ConfirmationService, DialogService],
  templateUrl: './department-default-lookup.component.html',
  styleUrl: './department-default-lookup.component.scss'
})
export class DepartmentDefaultLookupComponent {
  loader: boolean = false;
  warehouseId!: number;
  warehouseName!: string;

  departments: DepartmentDto[] = [];
  departmentMap: { [key: number]: DepartmentDto | undefined } = {};

  transactionTypes: any[] = [];
  departmentDefaults: any[] = [];

  constructor(
    private messageService: MessageService,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    public config: DynamicDialogConfig,
    private warehouseService: WarehouseService
  ) { }

  ngOnInit() {
    this.warehouseId = this.config.data?.warehouseId;
    this.warehouseName = this.config.data?.WarehouseName;
    this.loadDepartments();
    this.loadTransactionTypes();

  }

 loadDepartmentDefaults() {
  this.warehouseService.getDepartmentDefaults(this.warehouseId)
    .subscribe((res: any[]) => {
      res.forEach(saved => {
        const row = this.departmentDefaults.find(
          x => x.transactionId === saved.transactionTypeId  // no change here
        );
        if (row) {
          row.departmentId   = saved.departmentId;
          row.effectiveFrom  = saved.effectiveFrom ? new Date(saved.effectiveFrom) : null;
        }
      });
    });
}


 loadTransactionTypes() {
  this.warehouseService.getTransactionTypes().subscribe({
    next: (res: any[]) => {

      const activeTransactions = res.filter(t => t.isActive);

      const uniqueTransactions = Array.from(
        new Map(
          activeTransactions.map(item => [item.transactionType, item])
        ).values()
      );

      this.transactionTypes = uniqueTransactions;

      this.departmentDefaults = uniqueTransactions.map(t => ({
        transactionId: t.ruleId,
        transactionType: t.transactionType,
        transactionCode: t.transactionType,
        departmentId: null,
        departmentCode: null,
        effectiveFrom: null,
        isInvalid: false
      }));

      this.loadDepartmentDefaults();
    },
    error: (err) => console.error(err)
  });
}

  loadDepartments() {
    this.warehouseService.getDepartments().subscribe({
      next: (res: DepartmentDto[]) => {
        this.departments = res;
        res.forEach(d => this.departmentMap[d.departmentId] = d);
      },
      error: (err) => console.error(err)
    });
  }


  onDepartmentChange(row: any) {
    // if (!row.effectiveFrom) {
    //   row.effectiveFrom = new Date();
    // }

    const dept = this.departments.find(d => d.departmentId === row.departmentId);

    if (dept) {
      row.departmentCode = dept.code;
      row.departmentName = dept.name;
    }
  }


  saveDefaults() {
    // Check validation for each row
    const invalidRow = this.departmentDefaults.find(x =>
      (x.departmentId && !x.effectiveFrom)
    );

    if (invalidRow) {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation',
        detail: 'Please select Effective Date for all selected departments.'
      });
      return;
    }

    // const invalidIndex = this.departmentDefaults.findIndex(x =>
    //   (x.departmentId && !x.effectiveFrom)
    // );

    // if (invalidIndex !== -1) {
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Validation',
    //     detail: `Row ${invalidIndex + 1}: Please select Effective Date.`
    //   });
    //   return;
    // }

    const validRows = this.departmentDefaults.filter(
      x => x.departmentId && x.effectiveFrom
    );

    if (validRows.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Please select at least one department and effective date.'
      });
      return;
    }

    const username = localStorage.getItem('username');

    const payload = validRows.map(x => ({
      warehouseId: Number(this.warehouseId),
      transactionTypeId: x.transactionId,
      departmentId: x.departmentId,
      //effectiveFrom: x.effectiveFrom,
      effectiveFrom: this.formatDateToString(x.effectiveFrom),
      createdBy: username,
      updatedBy: username
    }));

    this.warehouseService.saveDepartmentDefaults(payload)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message
          });

          setTimeout(() => {
            this.ref.close(true);
          }, 500);

        },
        error: (err) => {
          console.error(err);
        }
      });
  }

  onCancel() {
    this.ref.close(false);
  }
  
  formatDateToString(date: Date | string): string {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }


}





